import { useState, useLayoutEffect, Fragment } from 'react';
import ServiceDirectoryMenu from '../../components/ServiceDirectoryMenu/ServiceDirectoryMenu';
import TextInformation from '../../components/TextInformation/TextInformation';
import useMediaQuery from '@mui/material/useMediaQuery';
import { MediumHeightDivider, SmallHeightDivider } from '../../theme/Styles';
import { Row, RowBodyDivider } from '../../theme/Styles';
import { Grid } from '@mui/material';
import ServiceCard from '../../components/ServiceCard/ServiceCard';
import {
  localDirections,
} from './ListOfServicesPerCategoryConstants';
import { useHistory } from 'react-router';
import LoginOrRegisterModal from '../../components/LoginOrRegisterModal/LoginOrRegisterModal';
import { useDispatch, useSelector } from 'react-redux';
import { UpdateAppSubHeaderTitle } from '../../redux/actions/UiActions';
import { useParams } from 'react-router-dom';
import { Container } from './styles/ListOfServicesPerCategoryStyles';
import { useTranslation } from 'react-i18next';
import {
  getAllServices,
} from '../../api/ListOfServicesPerCategory';
//tenative

import { useQuery } from 'react-query';
import CenterLoading from '../../components/CenterLoading/CenterLoading';

function ListOfServicesPerCategory() {
  const matchesWidth = useMediaQuery('(min-width:768px)');
  const history = useHistory();
  let { categoryID } = useParams();
  const dispatch = useDispatch();
  const { authenticated } = useSelector((state) => state.authReducer);

/*   const { data: allQuestionsData, isLoading: allQuestionsDataLoading } =
    useQuery(['allQuestionsData'], () => getAllQuestions()); */

  const { data: listOfServices, isLoading: listOfServicesLoading } = useQuery(['listOfServices'], () => getAllServices());

  const [t, i18n] = useTranslation('Service');
  const [loginOrRegisterModalStatus, setLoginOrRegisterModalStatus] = useState(false);
  const [currentDirection, setCurrentDirection] = useState();
  const [ListServicesState, setListServicesState] = useState([]);

  const handleServiceRequest = (serviceID) => {
    if (authenticated) {
      history.push(`/app/requestService/${serviceID}`);
    } else {
      setLoginOrRegisterModalStatus(!loginOrRegisterModalStatus);
    }
  };

  useLayoutEffect(() => {
    if (listOfServices != undefined) {
      let currentDirection = listOfServices.find((direction) => direction.id == categoryID)
      // TITLE OF SUBHEADER APP
      dispatch(UpdateAppSubHeaderTitle(currentDirection.name));
      setCurrentDirection(currentDirection);
      setListServicesState(currentDirection.services);
    }

  }, [i18n.language, categoryID, listOfServices]);

  if (/* allQuestionsDataLoading || */ listOfServicesLoading) return <CenterLoading />;

    return (
    <Container>
      <LoginOrRegisterModal
        open={loginOrRegisterModalStatus}
        onBackDropClick={() => setLoginOrRegisterModalStatus(false)}
        onCloseClick={() => setLoginOrRegisterModalStatus(false)}
      />
      <Row>
        {matchesWidth && (
          <Fragment>
            <ServiceDirectoryMenu />
            <RowBodyDivider />
          </Fragment>
        )}
        <Container style={{ width: '100%' }}>
          <TextInformation
            title='Información general'
            content={currentDirection?.description} />

          <SmallHeightDivider />

          {matchesWidth && (
            <Fragment>
              <TextInformation title={t('Services')} />
              <SmallHeightDivider />
              <Grid
                alignItems='center'
                container
                direction='row'
                justifyContent='flex-start'
                spacing={{ xs: 2, md: 3 }}
                columns={{ xs: 4, sm: 8, md: 12 }}
              >
                {ListServicesState?.map((item, index) => (
                  <Grid key={item.id} item>
                    <ServiceCard
                      itemId={item.id}
                      title={item?.name}
                      subTitle={item.description}
                      relationTo={
                        localDirections.find(
                          (direction) => direction.id == item.direction_id
                        )?.title
                      }
                      onRequestPress={() => handleServiceRequest(item.id)}
                      OnViewInformationPress={() =>
                        history.push(`/app/serviceDescription/${item.id}`)
                      }
                    />
                  </Grid>
                ))}
              </Grid>
            </Fragment>
          )}
          <MediumHeightDivider />
          <TextInformation title='Preguntas frecuentes' />
          <SmallHeightDivider />
          {/* 
            allQuestionsData[currentDirection?.wordpressKey]?.map((question) => (
              <div>
                <Collapsable
                  title={question.question}
                  content={question.answer}
                />
                <SmallHeightDivider />
              </div>
            )) */
          }
        </Container>
      </Row>
      {!matchesWidth && (
        <Fragment>
          <TextInformation title='Servicios' />
          <SmallHeightDivider />
          <Grid
            alignItems='center'
            container
            direction='row'
            justifyContent='center'
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            {ListServicesState?.map((item) => (
              <Grid item key={item.id}>
                <ServiceCard
                  itemId={item.id}
                  title={item.name}
                  subTitle={item.description}
                  relationTo={
                    localDirections.find(
                      (direction) => direction.id == item.direction_id
                    ).title
                  }
                  onRequestPress={() => handleServiceRequest(item.id)}
                  OnViewInformationPress={() =>
                    history.push(`/app/serviceDescription/${item.id}`)
                  }
                />
              </Grid>
            ))}
          </Grid>
        </Fragment>
      )}
    </Container>
  );
}

export default ListOfServicesPerCategory;
